export const version = "v 2.5.1";
export const siteURL = "https://wh-motd.pages.dev/";

// Comment to get this to push to main not master on cf
